import React, { useEffect, useState } from 'react'
import './index.less'
import { Form, Input, Button, Dropdown, message, Space, Checkbox } from 'antd'
import { useNavigate } from 'react-router-dom';
import { request, setToken, setUser } from '@/utils';
import NavigationBar from '@/components/NavigationBar'
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import wxIcon from '@/assets/wx.png'
import { Func, rsaEncrypt } from "@/utils/func";
import IconPswon from '@/assets/icon-psw-on.png'
import IconPswoff from '@/assets/icon-psw-off.png'
export default function Login() {
  const navigate = useNavigate()
  const [wxUrl, setWxUrl] = useState(""); // 初始倒计时值
  const [showPwd, setShowPwd] = useState(false)
  const [rememberPwd, setRememberPwd] = useState(false)
  const [areCode, setAreaCode] = useState('86')
  const [params, setParams] = useState({ mobile: null, password: null })
  const onFinish = () => {
    if (!areCode) {
      message.error('请选择区号')
      return false
    }
    if (!params.mobile) {
      message.error('请输入手机号码')
      return false
    }
    if (areCode === '86' && !/^1[3-9]\d{9}$/.test(params.mobile)) {
      message.error('请输入正确的手机号码')
      return false
    }
    if (!params.password) {
      message.error('请输入密码')
      return false
    }
    const postData = async () => { 
      let pwd = await rsaEncrypt(params.password);
      try {
        const response = await request.post('auth/mobile-login-web', {
          mobile: params.mobile,
          password: pwd,
          nation_code: areCode,
        });
        if (response.code) {
          message.error(response.msg)
        } else {
          setToken(response.data.token)
          response.data.token && message.success('登录成功')
          setUser(response.data)
          navigate('/')
          if (rememberPwd) {
            localStorage.setItem('areaCode', areCode);
            localStorage.setItem('mobile', params.mobile);
            localStorage.setItem('password', params.password);
          } else {
            localStorage.removeItem('areaCode');
            localStorage.removeItem('mobile');
            localStorage.removeItem('password');
          }
        }
        console.log(response.data);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };
    postData()
  };
  const toRegister = () => {
    navigate('/register')
  }
  const forgetPassword = () => {
    console.log('忘记密码');
    navigate('/forgetPassword')
  }

  const wxlogin = () => {
    const wxUrlReq = async () => {
      const response = await request.get('/wxxcx/get-login-url?redirect_url=' + window.location.href);
      setWxUrl(response.data)
    }
    wxUrlReq()
  }

  const setUserInfo = async () => {
    const responseInfo = await request.get('auth/info');
    responseInfo.data && setUser(responseInfo.data)
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    if (token) {
      setToken(token)
      setUserInfo().then(r => {
        navigate('/')
      });

    } else {
      wxlogin();
    }
    const savedMobile = localStorage.getItem('mobile');
    const savedPassword = localStorage.getItem('password');
    const saveAreaCode = localStorage.getItem('areaCode')
    if (savedMobile && savedPassword && saveAreaCode) {
      setRememberPwd(true);
      setAreaCode(saveAreaCode)
      params.mobile = savedMobile;
      params.password = savedPassword;
      setParams({ ...params })
    }
  }, [])
  const items = [
    {
      key: '1',
      label: (
        <div className='arecode' onClick={() => { setAreaCode('86') }}>
          <span className='code'> +86 </span><span>中国大陆</span>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div className='arecode' onClick={() => { setAreaCode('852') }}>
          <span className='code' > +852 </span><span>中国香港</span>
        </div>
      ),

    },
    {
      key: '3',
      label: (
        <div className='arecode' onClick={() => { setAreaCode('886') }}>
          <span className='code'> +886 </span><span>中国台湾</span>
        </div>
      ),
    },
    {
      key: '4',
      label: (
        <div className='arecode' onClick={() => { setAreaCode('853') }}>
          <span className='code'> +853 </span><span>中国澳门</span>
        </div>
      ),
    },
    {
      key: '5',
      label: (
        <div className='arecode' onClick={() => { setAreaCode('81') }}>
          <span className='code'> +81 </span><span>日本</span>
        </div>
      ),
    },
  ];
  useEffect(() => {

  }, []);
  return (
    <div className="login">
      <NavigationBar showNavRight={false} showNavTabs={false}></NavigationBar>
      <div className="login-container">
        <div className="right-box">
          <div className='login-header'>登录</div>
          <div className='label'>手机号码</div>
          <div className="phone-input">
            <Dropdown menu={{ items }} trigger={['click']}>
              <div className='areaCode'>
                <div className='codeValue' >+{areCode}</div>
                <DownOutlined style={{ fontSize: '14px' }} />
              </div>
            </Dropdown>
            <input placeholder="请输入手机号码" size="large" value={params.mobile} onInput={(e) => {
              params.mobile = e.target.value
              setParams({ ...params })
            }} />
          </div>
          <div className='label'>密码</div>
          <div className="phone-input">
            <input placeholder="请输入密码" size="large" type={showPwd ? 'text' : "password"} name="password"
              value={params.password} onInput={(e) => {
                params.password = e.target.value
                setParams({ ...params })
              }} />
            {
              showPwd ? <img className="pwd-icon" src={IconPswon} alt="" onClick={() => { setShowPwd(false) }} /> :
                <img className="pwd-icon" src={IconPswoff} alt="" onClick={() => { setShowPwd(true) }} />
            }
          </div>
          <div className="pwd-select">
            <Checkbox className="login-form-remember" checked={rememberPwd} onChange={(e) => { setRememberPwd(e.target.checked) }}>记住密码</Checkbox>
            <span className="login-form-forgot" onClick={forgetPassword}>
              忘记密码？
            </span>
          </div>

          <div>
            <Button type="primary" htmlType="submit" block className="login-form-button" size="large" onClick={onFinish}>
              登录
            </Button>
            <div className="login-bottom-item">
              <div className='registerAccount' onClick={toRegister}>注册新账号</div>
              <div className="registerAccount-right">其他登录方式<a href={wxUrl}><img className="login-icon" src={wxIcon} alt="" /></a></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}
